import * as React from 'react';
import './loading.css';

export const Loading = () => (
  <div className="loading-shading">
    <div className="loading-icon">
      <span className="oi oi-loop-circular" />
    </div>
  </div>
);
